import { Box, Stack, Typography } from '@mui/material';
import { FlightTakeoffRounded } from '@mui/icons-material';
import { APP_NAME } from '@/config/productBrand';
import type { LoginBrand } from './useLoginForm';

const PORTAL_TEXT: Record<string, { title: string; text: string }> = {
  Website: { title: 'Our website is on its way', text: 'We are getting our new website ready. Please check back soon.' },
  Vendor: { title: 'Supplier portal coming soon', text: 'Our suppliers will manage their services, rates and bookings here.' },
  B2B: { title: 'Agent portal coming soon', text: 'Travel agents will search, quote and book with us here.' },
  Customer: { title: 'Customer portal coming soon', text: 'Travellers will see their trips, vouchers and payments here.' },
};

/**
 * One of a company's own addresses whose portal is not built yet (website, vendor, B2B or customer). The address
 * is already the company's, in its colours and with its logo; the portal opens on it when it ships.
 */
export default function PortalComingSoon({ brand, portal }: { brand: LoginBrand | null; portal?: string }) {
  const copy = PORTAL_TEXT[portal ?? ''] ?? { title: 'Coming soon', text: 'This page is being prepared.' };
  const colour = brand?.primaryColor ?? '#1D4E89';
  const name = brand?.companyName ?? APP_NAME;

  return (
    <Box component="main" sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', bgcolor: '#F4F6FA', p: 2 }}>
      <Stack alignItems="center" spacing={2} sx={{ maxWidth: 480, textAlign: 'center', bgcolor: '#fff', borderRadius: 3, p: { xs: 3, sm: 5 }, border: '1px solid #E5E9F0', boxShadow: '0 12px 40px rgba(15,23,42,0.06)' }}>
        {brand?.logoUrl
          ? <Box component="img" src={brand.logoUrl} alt={name} sx={{ maxHeight: 64, maxWidth: 200, objectFit: 'contain' }} />
          : <Box sx={{ width: 56, height: 56, borderRadius: 3, bgcolor: colour, color: '#fff', display: 'grid', placeItems: 'center' }}><FlightTakeoffRounded /></Box>}
        <Typography sx={{ fontWeight: 700, fontSize: 18, color: colour }}>{name}</Typography>
        <Typography component="h1" sx={{ fontWeight: 800, fontSize: 24, color: '#0F172A' }}>{copy.title}</Typography>
        <Typography sx={{ color: '#64748B' }}>{copy.text}</Typography>
      </Stack>
    </Box>
  );
}
